(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 2387:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners",
      function () {
        return __webpack_require__(9059);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _app_components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6625);
/* harmony import */ var _app_components_gradient_gradient_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3725);
/* harmony import */ var _app_constants_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9510);
/* harmony import */ var _app_contexts_theme_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9746);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);







var ConnectSection = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "dark" : _variant;
    var isLightVariant = variant === "light";
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var isMobile = (0,_app_contexts_theme_context__WEBPACK_IMPORTED_MODULE_3__/* .useThemeContext */ .TC)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-4 pt-8 md:px-12 md:pt-12 lg:px-24 lg:pt-24 ".concat(isLightVariant ? "" : "bg-background-primary-dark-dark", "  \n      flex flex-col items-center justify-between md:gap-y-16"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-y-5 items-center text-center max-w-[700px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_gradient_gradient_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "h4 md:h3",
                            children: isLightVariant ? "Let's get connected!" : "Connect with us!"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-body-md lg:subheading ".concat(isLightVariant ? "text-text-color-mid-em" : "text-light"),
                        children: isLightVariant ? "If your company is looking for a strong partner within the waste and recycling industry, we'd like to hear from you." : "If you're looking for a strong partner within the waste and recycling\n          industry, we'd like to hear from you."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "py-5 w-full md:w-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            buttonType: "gradient",
                            onClick: function() {
                                return router.push("/".concat(_app_constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .CONTACT_PAGE */ .rU));
                            },
                            full: isMobile,
                            className: isMobile ? "rounded-full" : "",
                            children: isLightVariant ? "Connect with us!" : "Let's connect!"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "rounded-t-3xl border overflow-hidden border-4 xs:border-8 border-b-0 h-fit -mb-2 xs:-mb-4\n        ".concat(isLightVariant ? "border-black" : "border-white"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    width: 1216,
                    height: 428,
                    src: "/images/acquisitions/connect.png",
                    alt: "Join us"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConnectSection);


/***/ }),

/***/ 9467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var GradientContainer = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _gradientDirection = param.gradientDirection, gradientDirection = _gradientDirection === void 0 ? "bg-gradient-to-tl" : _gradientDirection, overrideClassName = param.overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(gradientDirection, " ").concat(light ? "from-[#86EFAC] to-[#67E8F9]" : "from-[#22C55E] to-[#06B6D4]", "\n    ").concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GradientContainer);


/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var TextGradient = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _overrideClassName = param.overrideClassName, overrideClassName = _overrideClassName === void 0 ? "" : _overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundImage: light ? "linear-gradient(to right, #86EFAC, #67E8F9)" : "linear-gradient(to right, #06B6D4, #22C55E)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent"
        },
        className: "".concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextGradient);


/***/ }),

/***/ 9059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ partners; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/connect-section.tsx
var connect_section = __webpack_require__(221);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/partners-sections/expectations-section/bottom-content.tsx


var ExpectationsSectionBottomContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col-reverse md:grid md:grid-cols-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 md:mt-0 md:col-span-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-[200px] xs:min-h-[400px] md:min-h-[560px] h-full w-full bg-cover bg-left md:bg-center bg-no-repeat rounded-xl md:rounded-tl-none md:rounded-bl-none md:rounded-tr-xl md:rounded-br-xl",
                    style: {
                        backgroundImage: "url('/images/partners/expectations-03.png')"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:col-span-6 md:p-12 lg:p-24 flex items-center justify-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:max-w-[528px] flex flex-col items-start justify-center space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/icons/mdi-account-multiple.png",
                            alt: "Creative Synergies",
                            height: 40,
                            width: 40
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mobile-h4 md:h5 lg:h4 text-text-color-high-em",
                            children: "Creative Synergies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-text-color-mid-em",
                            children: "At SimpleWaste we employ principal strategies that support a unified purpose. These strategies are carefully designed through market research, technology integrations, creative structuring, and synergistic campaigns. \u200B"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var bottom_content = (ExpectationsSectionBottomContent);

// EXTERNAL MODULE: ./components/gradient/gradient-container.tsx
var gradient_container = __webpack_require__(9467);
;// CONCATENATED MODULE: ./components/partners-sections/expectations-section/mid-content.tsx



var ExpectationSectionMidContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col space-y-8 md:space-y-12 lg:space-y-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center space-y-8 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mobile-h3 md:h4 lg:h3 text-base-dark",
                                children: "Let's exceed expectations"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-2 w-36"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "subheading text-text-color-mid-em",
                        children: "Industry solutions your customers will love."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-12 gap-y-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-12 md:col-span-6 md:p-12 lg:p-24 flex items-center justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:max-w-[528px] flex flex-col items-start justify-center space-y-4 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/assets/icons/mdi-circuit-chip.png",
                                    alt: "Technology Advantages",
                                    height: 40,
                                    width: 40
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mobile-h4 md:h5 lg:h4 text-text-color-high-em",
                                    children: "Technology Advantages"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-text-color-mid-em",
                                    children: "Our platform is guaranteed to deliver the innovation your customers have been looking for. Stay updated on rollout progress with the SimpleWaste partner-facing interface: review customer experience, opportunity, and KPIs.\u200B"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-12 md:col-span-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "min-h-[200px] xs:min-h-[400px] md:min-h-[560px] h-full w-full bg-cover bg-top bg-no-repeat rounded-xl md:rounded-tr-none md:rounded-br-none md:rounded-tl-xl md:rounded-bl-xl",
                            style: {
                                backgroundImage: "url('/images/partners/expectations-02.png')"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mid_content = (ExpectationSectionMidContent);

;// CONCATENATED MODULE: ./components/partners-sections/expectations-section/index.tsx



var ExpectationsSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "px-8 py-16 md:px-0 md:py-12 lg:py-24 flex flex-col space-y-8 md:space-y-12 lg:space-y-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mid_content, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_content, {})
        ]
    });
};
/* harmony default export */ var expectations_section = (ExpectationsSection);

// EXTERNAL MODULE: ./components/gradient/gradient-text.tsx
var gradient_text = __webpack_require__(3725);
;// CONCATENATED MODULE: ./components/partners-sections/looking-for-section.tsx



var LookingForSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 gap-y-8 px-8 pt-8 md:px-0 md:pt-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-6 md:mr-0 lg:my-24 lg:ml-24 md:pl-6 flex items-center justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            overrideClassName: "mobile-h2 md:h3 lg:h2 pb-6",
                            children: "We've got what they're looking for."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-body-md lg:text-body-lg text-text-color-mid-em",
                            children: "Get your customers excited about trash.\u200B A comprehensive solution has made it to the waste industry.\n            We\u2019ve got it. Let\u2019s share it."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-12 md:col-span-6 md:pl-20 flex justify-center md:justify-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/partners/hero.png",
                            alt: "Waste Industry",
                            height: 640,
                            width: 640
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/partners/hero-mobile.png",
                            alt: "Waste Industry",
                            height: 640,
                            width: 640
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var looking_for_section = (LookingForSection);

;// CONCATENATED MODULE: ./components/partners-sections/point-of-view-section/bottom-content.tsx

var PointOfViewSectionBottomContent = function() {
    var sectionContents = [
        {
            title: "Channel Partner benefits",
            underlineColorClass: "bg-secondary-light",
            content: "We provide leading-edge tracking systems, technology integrations, ancillary expansion \n      opportunities and rev-share options. \n      Let\u2019s review your position and find a starting place."
        },
        {
            title: "Qualities we look for",
            underlineColorClass: "bg-primary-light",
            content: "We\u2019re looking for specific qualities in channel partners. \n      Does your company provide reliable volume and margin? \n      Do you engage your customers with new partner programs?"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col-reverse lg:grid lg:grid-cols-12 2xl:w-2/3 overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-16 lg:mt-0 lg:col-span-5 flex justify-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-[756px] rounded-2xl h-full w-full bg-cover bg-right-top bg-no-repeat",
                    style: {
                        backgroundImage: "url('/images/partners/point-of-view-02.png')"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:col-span-7 flex flex-col items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-start justify-center lg:p-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "label-lg mb-4",
                            children: "Become a partner."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col space-y-10 lg:space-y-20",
                            children: sectionContents.map(function(content) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mobile-h3 md:h5 lg:h3",
                                            children: content.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-2 w-[200px] ".concat(content.underlineColorClass)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "subheading",
                                            children: content.content
                                        })
                                    ]
                                }, content.title);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var point_of_view_section_bottom_content = (PointOfViewSectionBottomContent);

;// CONCATENATED MODULE: ./components/partners-sections/point-of-view-section/top-content.tsx


var PointOfViewSectionTopContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 2xl:w-2/3 rounded-2xl overflow-hidden bg-light",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-7 flex flex-col items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-start justify-center p-8 md:p-16 space-y-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/icons/eye-gradient.png",
                            width: 48,
                            height: 48,
                            alt: "outlook"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mobile-h4 md:h5 lg:h4 text-secondary",
                            children: "Our point of view"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-body-lg text-text-color-mid-em",
                            children: [
                                "At",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-secondary-dark label-lg-bold",
                                    children: "SimpleWaste"
                                }),
                                " ",
                                "we\u2019re looking into the industry\u2019s future, making moves and incorporating innovations that benefit our clients, our stakeholders, and partners.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "We\u2019re looking for like-minded partners who possess excellence in business practice with a distinct focus on customer experience."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-5 flex justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-[420px] h-full w-full bg-cover bg-top md:bg-center bg-no-repeat",
                    style: {
                        backgroundImage: "url('/images/partners/point-of-view-01.png')"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var top_content = (PointOfViewSectionTopContent);

;// CONCATENATED MODULE: ./components/partners-sections/point-of-view-section/index.tsx



var PointOfViewSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col items-center bg-background-primary-dark-dark text-light px-8 py-16 md:p-12 space-y-10 md:space-y-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_content, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(point_of_view_section_bottom_content, {})
        ]
    });
};
/* harmony default export */ var point_of_view_section = (PointOfViewSection);

;// CONCATENATED MODULE: ./pages/partners/index.tsx





var PartnersPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(looking_for_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(expectations_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(point_of_view_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(connect_section/* default */.Z, {
                variant: "light"
            })
        ]
    });
};
/* harmony default export */ var partners = (PartnersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);